import ACTIONS from "../../constants/actions";

const initialState = {
	payments : [],
	cancel   : [],
	fetching : true
};

export default function payments(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.PAYMENTS.GET_HISTORY: {
			const newState = {
				payments : action.data.payments,
				fetching : false
			};
			return Object.assign({}, {...state, ...newState});
		}

		case ACTIONS.PAYMENTS.CANCEL: {
			const newState = {
				cancel   : action.data,
				fetching : false
			};
			return Object.assign({}, {...state, ...newState});
		}
		default:
			break;
	}


	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/payments.js